export default "__VITE_ASSET__DjGGV5cR__"